import classNames from 'classnames';
import React from 'react';
import { Tooltip } from 'react-bootstrap';
import { ClickableLabel } from './ClickableLabel';
import { WeightInfo } from '../../types';
import { GoalLabel } from './GoalLabel';
import { GoalLabelWithTooltip } from './GoalLabelWithTooltip';

type Props = {
  weightInfo: WeightInfo;
  goalId: string;
  onClick?: () => void;
};

export const GoalWeightLabel: React.FC<Props> = ({
  weightInfo,
  goalId,
  onClick,
}) => {
  const hasErrors =
    !weightInfo.valid &&
    weightInfo.errorMessages &&
    weightInfo.errorMessages.length > 0;

  if (hasErrors) {
    return (
      <ClickableLabel onClick={onClick}>
        <GoalLabelWithTooltip
          icon="phosphor-scales"
          label={`${weightInfo.weight}%`}
          className="me-3 text-warning"
          tooltip={
            <Tooltip id={`weight-error-tooltip-${goalId}`}>
              {weightInfo.errorMessages!.length === 1 ? (
                <span>{weightInfo.errorMessages![0]}</span>
              ) : (
                <ul className="list-unstyled text-start mb-0">
                  {weightInfo.errorMessages!.map((msg, index) => (
                    <li key={index}>• {msg}</li>
                  ))}
                </ul>
              )}
            </Tooltip>
          }
        />
      </ClickableLabel>
    );
  }

  return (
    <ClickableLabel onClick={onClick}>
      <GoalLabel
        icon="phosphor-scales"
        label={`${weightInfo.weight}%`}
        className={classNames('me-3', !weightInfo.valid && 'text-warning')}
      />
    </ClickableLabel>
  );
};
